<script setup lang="ts">
import { ref } from 'vue'
import { VIcons } from '@/shared/ui'

const visible = ref(false)
const visibleHandler = () => (visible.value = !visible.value)
</script>

<template>
  <VTextField :type="visible ? 'text' : 'password'" autocomplete="new-password">
    <template #append-inner>
      <VIcons
        :type="visible ? 'visibility_off' : 'visibility'"
        class="password__icon"
        @click="visibleHandler"
      />
    </template>
  </VTextField>
</template>
